module.exports = __webpack_public_path__ + "media/svg-new/product-management-4e8960e3.svg";